module.exports = __webpack_public_path__ + "static/img/wangping.af0f32a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/haibao_vx/wangping.png
// module id = 2vBo
// module chunks = 0